import { featureFlagService, FLAG_BLANCCO_TRANSLATOR } from "services/feature/FeatureFlagService";
import { getObject, RepositoryKey } from "utils/repository";

interface NewNamespaceLocation {
    directory: string;
    filePrefix: string;
}

// TODO BCC-7971: Remove /locales once new translator is in use.
const LOCALIZATION_ROOT = "../../public/localization";
const LEGACY_LOCALES_ROOT = "../../public/locales";

const NEW_NAMESPACE_LOCATIONS: Record<string, NewNamespaceLocation> = {
    translation: { directory: "translation", filePrefix: "translation" },
    reportPaths: { directory: "report-paths", filePrefix: "reportPaths" },
    diagnosticReasonCodes: { directory: "diagnostic-reason-codes", filePrefix: "diagnosticReasonCodes" },
    assetPaths: { directory: "asset-paths", filePrefix: "assetPaths" },
};

export const LEGACY_LANGUAGE_CODES = ["en_US", "fr_FR", "de_DE", "ja_JP", "es_ES", "pt_BR", "zh_CN", "ko_KR"];

const DEV_ONLY_LANGUAGE_CODE = "fi_FI";

export const NAMESPACES = Object.keys(NEW_NAMESPACE_LOCATIONS);

export function isNewLocalizationEnabled(): boolean {
    return featureFlagService.isFeatureEnabled(FLAG_BLANCCO_TRANSLATOR);
}

export function isFinnishLocalizationEnabled(): boolean {
    return getObject<boolean>(RepositoryKey.USE_FINNISH_LOCALIZATION) === true;
}

export function getSupportedLanguageCodes(useNewLocalization: boolean): string[] {
    return useNewLocalization ? [...LEGACY_LANGUAGE_CODES, DEV_ONLY_LANGUAGE_CODE] : LEGACY_LANGUAGE_CODES;
}

export function resolveLanguageCode(
    userLanguageCode: string,
    useNewLocalization: boolean,
    useFinnish: boolean
): string {
    return useNewLocalization && useFinnish ? DEV_ONLY_LANGUAGE_CODE : userLanguageCode;
}

export function buildLoadPath(
    languageCode: string,
    namespace: string,
    useNewLocalization: boolean,
    version: string
): string {
    if (!useNewLocalization) {
        return `${LEGACY_LOCALES_ROOT}/${languageCode}/${namespace}.json?version=${version}`;
    }
    const location = NEW_NAMESPACE_LOCATIONS[namespace];
    if (location === undefined) {
        throw new Error(`No new localization location is configured for namespace: ${namespace}`);
    }
    return `${LOCALIZATION_ROOT}/${location.directory}/${location.filePrefix}_${languageCode}.json?version=${version}`;
}
